import StudentsSettingsPage from "@/account/StudentsSettingsPage";
import withSettingsDirectoryPrivileges from "@/account/withSettingsDirectoryPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";

const SettingsStudentsPageRoute = () => (
  <NewselaGlobalLayout mainContents={<StudentsSettingsPage />} />
);

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default withSettingsDirectoryPrivileges(SettingsStudentsPageRoute);
